import { AreaItem } from '@/types/cms/AreaItem'
import styles from './TeaserHighlight_3.module.scss'
import React from 'react'
import TeaserHighlight from '@/elements/widgets/Teaser/Highlight/TeaserHighlight'
import { clsx } from 'clsx'

const TeaserHighlight_3 = ({ item }: { item: AreaItem }) => {
  const isTyped = (type: string) => {
    return ['video', 'gallery'].includes(type)
  }

  return (
    <section className={clsx(styles.section, item?.model?.fields?.mobile && styles.mobile)}>
      {item?.items?.map((teaser: any, index: number) => {
        return (
          <TeaserHighlight item={teaser} key={index} options={item?.model?.fields}>
            <div className={clsx(styles['text-container'], isTyped(teaser.type) && styles.typed)}>
              <div className={styles.headline}>{teaser.model.headline}</div>
            </div>
          </TeaserHighlight>
        )
      })}
    </section>
  )
}

export default TeaserHighlight_3
